import AuthProvider from './auth/AuthProvider';
import AppRoter from './router/AppRouter';

function App() {

  return (
    //#region old code
    // <div className='container mt-5'>
    //   <h1>CHEJ Consultor, C.A.</h1>
    //   <div className='form-check form-switch'>
    //     <input className='form-check-input' type='checkbox' id='flexSwitchCheckDefault' />
    //     <label className='form-check-label' htmlFor='flexSwitchCheckDefault'>Default switch checkbox input</label>
    //   </div>
    // </div>
    //#endregion old code
    <AuthProvider>
      <div className='wrapper'>
        <AppRoter />
      </div>
    </AuthProvider>
  );
}
export default App;